<app-crud-create [fields]="fields" [title]="'establecimiento'"
  [description]="'En esta sección podrás ingresar el detalle del Establecimiento'"
  [apiService]="apiService"
  >
</app-crud-create>
